<script setup>
// §8.4 SyncIndicator (P1, Mobile) — queued vs synced. Shape + label, never
// colour alone (D6). Uses neutral/interactive tokens only — "queued" is not a
// status hue, it is a transient system state.
import { computed } from 'vue'
import LIcon from '../base/Icon.vue'

const props = defineProps({
  state: { type: String, default: 'synced' }, // synced | queued | offline
})
const MAP = {
  synced: { label: 'Synced', icon: 'check' },
  queued: { label: 'Queued', icon: 'arrows-rotate' },
  offline: { label: 'Offline', icon: 'ban' },
}
const meta = computed(() => MAP[props.state] ?? MAP.synced)
</script>

<template>
  <span class="l-sync" :data-s="state">
    <LIcon :name="meta.icon" :size="12" :spin="state === 'queued'" />
    {{ meta.label }}
  </span>
</template>

<style scoped>
.l-sync {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: var(--text-chip);
  font-weight: 600;
  color: var(--text-3);
}
.l-sync[data-s='synced'] { color: var(--status-approved-text); }
.l-sync[data-s='queued'] { color: var(--interactive-text); }
.l-sync[data-s='offline'] { color: var(--text-3); }
</style>
